<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialog.status"
          @keydown.esc="dialog.status = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Nonaktifkan Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.status = false; dialog.fullscreen = false; reset();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menonaktifkan data <b class="font-weight-bold black--text">{{ form.name }}</b>?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="toStatus()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Yakin
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.status = false; dialog.fullscreen = false; reset();"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->

        <v-dialog v-model="dialog.status"
          @keydown.esc="dialog.status = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Ubah Status Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.status = false; dialog.fullscreen = false; reset();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin mengubah status data <b class="font-weight-bold black--text">{{ form.name }}</b>?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="toStatus()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Ubah
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.status = false; dialog.fullscreen = false; reset();"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; reset();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ form.name }}</b>?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="toDelete()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; reset();"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <!-- <div>
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      Parent (Aktiva Diatasnya)
                    </div>

                    <v-autocomplete
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih salah satu bila diperlukan"

                      hide-details
                      clearable
                      item-text="name"
                      item-value="id"
                      :items="parent"

                      v-model="form.par_id"
                      class="mb-6"
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </div> -->

                  <ValidationProvider
                    name="Type" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Type
                    </div>

                    <v-autocomplete

                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
                      :autofocus="true"

                      persistent-hint
                      @focus="$event.target.blur()"
                      

                      :color="set_color"
                      placeholder="Pilih salah satu bila diperlukan"

                      hide-details
                      clearable
                      item-text="name"
                      item-value="id"
                      :items="[
                        { id: 'aktiva', name: 'Aktiva' },
                        { id: 'pasiva', name: 'Pasiva' },
                        { id: 'pendapatan', name: 'Pendapatan' },
                        { id: 'biaya', name: 'Biaya' }
                      ]"

                      v-model="form.type"
                      :success="form.type !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.type !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  
                  </ValidationProvider>

                  <ValidationProvider
                    name="Nomor" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nomor
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nomor"

                      hide-details

                      v-model="form.number"
                      :success="form.number !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.number !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Nama" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nama
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nama"

                      hide-details

                      v-model="form.name"
                      :success="form.name !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <!-- <ValidationProvider
                    name="Tag" 
                    rules="required" 
                    v-slot="{ errors, valid }"> -->
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <!-- <span class="red--text">*</span> -->
                      Tag
                    </div>

                    <v-autocomplete
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih salah satu bila diperlukan"

                      hide-details
                      clearable
                      item-text="name"
                      item-value="id"
                      :items="[ { id: 'kas', name: 'Kas' }, { id: 'bank', name: 'Bank' }, { id: 'piutang', name: 'Piutang' }, { id: 'hutang', name: 'Hutang' }, { id: 'pendapatan', name: 'Pendapatan' }, { id: 'biaya', name: 'Biaya' }, { id: 'laba rugi', name: 'Laba Rugi' } ]"

                      v-model="form.tag"
                      class="mb-6"
                      style="border-radius: 10px;">
                    </v-autocomplete>
                    <div v-if="form.type === 'pasiva'">
                      <v-checkbox
                        v-model="form.laba_bool"
                        :label="`Jadikan Akun Laba Bulan Berjalan`">
                      </v-checkbox>
                    </div>
                  <!-- </ValidationProvider> -->
                  <!-- <div v-if="form.id === ''">
                    <ValidationProvider 
                      name="Tahun" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <div class="mb-2 font_weight_600 fs-13 black_one">
                        <span class="red--text">*</span>
                        
                        Tahun
                      </div>
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
  
                        filled
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Contoh. 2024"
  
                        hide-details
  
                        :items="years"
                        :item-color="set_color"
  
                        v-model="form.year"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-8"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tahun {{ errors[0] }}
                            </v-tooltip>
                          </div>
                          
                          <div v-if="form.year !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                  </div> -->
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.formSub"
          @keydown.esc="dialog.formSub = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <div 
              class="d-flex align-start pa-4 popup-header">
              <div
                class="fs-17 font-weight-bold" style="width: 450px;">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }} Sub di {{ name_par }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.formSub = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>

                  <ValidationProvider
                    name="Nomor" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nomor
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nomor"

                      hide-details
                      autofocus

                      v-model="form.number"
                      :success="form.number !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.number !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Nama" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Nama
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nama"

                      hide-details

                      v-model="form.name"
                      :success="form.name !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <!-- <ValidationProvider
                    name="Tag" 
                    rules="required" 
                    v-slot="{ errors, valid }"> -->
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <!-- <span class="red--text">*</span> -->
                      Tag
                    </div>

                    <v-autocomplete
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih salah satu bila diperlukan"

                      hide-details
                      clearable
                      item-text="name"
                      item-value="id"
                      :items="[ { id: 'kas', name: 'Kas' }, { id: 'bank', name: 'Bank' }, { id: 'piutang', name: 'Piutang' }, { id: 'hutang', name: 'Hutang' }, { id: 'pendapatan', name: 'Pendapatan' }, { id: 'biaya', name: 'Biaya' }, { id: 'laba rugi', name: 'Laba Rugi' } ]"

                      v-model="form.tag"
                      class="mb-6"
                      style="border-radius: 10px;">
                    </v-autocomplete>
                    <div v-if="form.id !== ''">
                      <div class="mb-2 font_weight_600 fs-13 black_one">
                        <!-- <span class="red--text">*</span> -->
                        Status
                      </div>
                      <v-select
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Pilih salah satu bila diperlukan"
  
                        hide-details
                        clearable
                        item-text="name"
                        item-value="id"
                        :items="[ { id: true, name: 'Aktif' }, { id: false, name: 'Nonaktif' } ]"
  
                        v-model="form.active_bool"
                        class="mb-6"
                        style="border-radius: 10px;">
                      </v-select>
                    </div>

                    <div v-if="form.type === 'pasiva'">
                      <v-checkbox
                        v-model="form.laba_bool"
                        :label="`Jadikan Akun Laba Bulan Berjalan`">
                      </v-checkbox>
                    </div>
                  <!-- </ValidationProvider> -->
                  <!-- <div v-if="form.id === ''">
                    <ValidationProvider 
                      name="Tahun" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <div class="mb-2 font_weight_600 fs-13 black_one">
                        <span class="red--text">*</span>
                        
                        Tahun
                      </div>
  
                      <v-select
                        v-on:keyup.enter="save()"
  
                        filled
                        rounded
                        dense
  
                        :color="set_color"
                        placeholder="Contoh. 2024"
  
                        hide-details
  
                        :items="years"
                        :item-color="set_color"
  
                        v-model="form.year"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-8"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tahun {{ errors[0] }}
                            </v-tooltip>
                          </div>
                          
                          <div v-if="form.year !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-select>
                    </ValidationProvider>
                  </div> -->
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.formSub = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Detail Perusahaan

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0" v-if="Object">
              <v-form>
                <v-row>
                  <v-col cols="6">
                    
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.detail = false; dialog.fullscreen = false; ">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        
        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Pegawai
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      to="/user/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row> -->

          <v-card
            flat
            color="transparent">
            <v-card-text class="pt-1 pb-0">
              <div
                class="d-flex align-center">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="22">
                    <v-img
                      contain
                      alt="kominfoklaten"  
                      :src="require('@/assets/image/grip_menu.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
  
                  <span
                    class="fs-16 black--text ml-2"
                    style="font-weight: 600;">
                    Chart of Account
                  </span>
                </div>
  
                <v-spacer />
  
              </div>
            </v-card-text>
          </v-card>

          <!-- <v-row
            justify="end"
            class="pa-4 py-0 pr-1"> -->
            <!-- <v-col cols="7">
              <div
                class="d-flex align-center">
                <v-avatar
                  tile
                  size="30">
                  <v-img
                    contain
                    alt="kominfoklaten"  
                    :src="require('@/assets/image/grip_menu.png')">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span
                  class="title black--text ml-2"
                  style="font-weight: 600;">
                  pembelian/item
                </span>
              </div>
            </v-col> -->
            <!-- <v-col
              cols="12"
              md="5"
              class="d-flex align-center">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                style="border-radius: 10px;">
              </v-text-field> -->

              <!-- FILTER -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.filter = true">
                      <v-icon size="18">mdi-filter-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Filter
                  </span>
                </v-tooltip>
              </div> -->

              <!-- FREEZE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.freeze = true">
                      <v-icon size="18">mdi-table-split-cell</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Freeze
                  </span>
                </v-tooltip>
              </div> -->

              <!-- HIDE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.hide = true">
                      <v-icon size="18">mdi-eye-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Hide
                  </span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row> -->

          <v-row
            class="pa-5 pt-2 pb-0">
            <v-col 
              cols="12"
              class="py-0">
              <div class="d-flex pb-2">
                <!-- <div>
                  <v-text-field
                    @click:clear="search = ''; fetch();"
                    v-on:keyup.enter="fetch()"
  
                    filled
                    rounded
                    dense
                    single-line
  
                    hide-details
                    :color="set_color"
                    placeholder="Cari data yang Anda butuhkan . . ."
                    append-icon="mdi-magnify"
                    clearable
  
                    v-model="search"
                    style="border-radius: 10px;">
                  </v-text-field>
                </div> -->
                <!-- <div>
                  <v-select
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. 2023"
                  class="ml-4"
                  hide-details

                  :items="years"
                  :item-color="set_color"

                  v-model="filter.year"
                  style="border-radius: 10px; width: 116px;">
                </v-select>
                </div> -->
                <v-btn
                  color="#4B4B4B"
                  elevation="0"
                  small
                  min-height="30"
                  @click="reset(); dialog.form = true"
                  class="fs-12 white--text text-capitalize d-flex align-center"
                  style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                  <v-icon size="15">mdi-plus-circle-multiple</v-icon>
                  
                  <span
                    class="ml-2 ">
                    Tambah
                  </span>
                </v-btn>
                <div class="ml-3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :loading="process.export"
                        elevation="0"
                        outlined
                        dark
                        min-height="30"
                        small
                        min-width="30"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 6px;"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon size="15">mdi-tray-full</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Export
                    </span>
                  </v-tooltip>
                </div>
              </div>
              <div class="d-flex" style="width: 100%;">
                <v-card 
                  flat
                  :style="process.load ? 'width: 100%;' : 'width: fit-content'"
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
  
                  <v-card-text class="px-0 pt-0 pb-2">
  
                    <div v-if="process.load">
                      <v-skeleton-loader
                        v-for="n in 10"
                        :key="n"
                        type="list-item-avatar"
                      ></v-skeleton-loader>
                    </div>
                    <div v-if="!process.load">
                      <!-- <div v-for="(item, index) in list" :key="index">
                        {{ item.name }}
                        <div v-for="(ch1, i) in item.children" :key="i">
                          {{ ch1.name }}
                          <div v-for="(ch2, i2) in ch1.children" :key="i2">
                            {{ ch2.name }}
                          </div>
                        </div>
                      </div> -->
                      <table style="width: 100%;">
                        <tr>
                          <td class="px-5 fs-12 font-weight-bold white--text py-1" style="background: #080679;">
                            Nomor Akun
                          </td>
                          <td class="text-left px-4 pl-1 py-1 fs-12 font-weight-bold white--text" style="background: #080679; width: 500px; min-width: 500px;">
                            <!-- border: 1px solid #eee; border-top: 0px; border-bottom: 0px; -->
                            Nama Akun
                          </td>
                          <td class="text-left px-4 py-1 fs-12 pl-0 font-weight-bold white--text" style="background: #080679; width: 315px; max-width: 315px; min-width: 315px;">
                            Tag
                          </td>
                        </tr>
                      </table>
                      <div style="height: calc(100vh - 210px); overflow-y: auto; padding-right: 8px; width: fit-content">
                        <table style="width: 100%; position: sticky; top: 0; background: #fff; z-index: 1;">
                          <tr>
                            <td class="px-5 fs-12 font-weight-bold black_one py-2" style="min-width: 312px; border-top: 1px solid #eee;">
                              Aktiva
                            </td>
                          </tr>
                        </table>
                        <v-treeview
                          v-model="tree"
                          :items="list_aktiva"
                          item-key="id"
                          activatable
                          open-all
                          item-children="child"
                          item-text="test"
                          class="border_buttom_tree fs-12"
                        >
                          <template v-slot:prepend="{ item }">
                            <!-- <v-icon v-if="item.child">
                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                            <div class="d-flex">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.formSub = true; reset(item);"
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-square-edit-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Ubah</span>
                              </v-tooltip>
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    v-if="item.last === undefined"
                                    rounded
                                    @click="dialog.formSub = true; resetSub(item);"
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-plus-circle</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.delete = true; reset(item);"
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-trash-can-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Hapus</span>
                              </v-tooltip>
                              <div :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600' : ''">
                                {{ item.number }}
                              </div>
                            </div>
    
                            <!-- <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  min-width="24"
                                  min-height="24"
                                  x-small
                                  rounded
                                  @click="dialog.status = true; reset(item);"
                                  color="orange"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon size="12">mdi-file-cancel</v-icon>
                                  
                                </v-btn>
                              </template>
      
                              <span>Nonaktifkan</span>
                            </v-tooltip> -->
    
  
                          </template>
                          <!-- <template v-slot:label="{item}">
                            <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                          </template> -->
                          <template v-slot:append="{ item }">
                            <div class="d-flex">
                              <div style="min-width: 500px; padding-left: 16px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.name }}
                              </div>
                              <div style="min-width: 300px; padding-left: 16px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.tag === '' || item.tag === null ? '-' : item.tag }}
                              </div>
                            </div>
                          </template>
                        </v-treeview>
    
                        <table style="width: 100%; position: sticky; top: 0; background: #fff; z-index: 1;">
                          <tr>
                            <td class="px-5 fs-12 font-weight-bold black_one py-2" style="min-width: 312px; border-top: 1px solid #eee;">
                              Pasiva
                            </td>
                          </tr>
                        </table>
                        <v-treeview
                          v-model="tree"
                          :items="list_pasiva"
                          item-key="id"
                          activatable
                          open-all
                          item-children="child"
                          item-text="test"
                          class="border_buttom_tree fs-12"
                        >
                          <template v-slot:prepend="{ item }">
                            <div class="d-flex" v-if="item.laba_bool === false">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.formSub = true; reset(item);"
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-square-edit-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Ubah</span>
                              </v-tooltip>
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    v-if="item.last === undefined"
                                    rounded
                                    @click="dialog.formSub = true; resetSub(item);"
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-plus-circle</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
      
                              <!-- <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="24"
                                    min-height="24"
                                    x-small
                                    rounded
                                    @click="dialog.status = true; reset(item);"
                                    color="orange"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-file-cancel</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Nonaktifkan</span>
                              </v-tooltip> -->
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.delete = true; reset(item);"
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-trash-can-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Hapus</span>
                              </v-tooltip>
                              <div :class="item.child.length > 0 || item.is_parent === true ? 'font_weight_600' : ''">
                                {{ item.number }}
                              </div>
                            </div>
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                            <div class="d-flex" style="cursor: pointer;" v-bind="attrs"
                                  v-on="on" v-if="item.laba_bool === true">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.formSub = true; reset(item);"
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-square-edit-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Ubah</span>
                              </v-tooltip>
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    v-if="item.last === undefined"
                                    rounded
                                    @click="dialog.formSub = true; resetSub(item);"
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-plus-circle</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
      
                              <!-- <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="24"
                                    min-height="24"
                                    x-small
                                    rounded
                                    @click="dialog.status = true; reset(item);"
                                    color="orange"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-file-cancel</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Nonaktifkan</span>
                              </v-tooltip> -->
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.delete = true; reset(item);"
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-trash-can-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Hapus</span>
                              </v-tooltip>
                              <div :class="item.child.length > 0 || item.is_parent === true ? item.laba_bool === true ? 'pink--text text--darken-1 font_weight_600' : 'font_weight_600' : item.laba_bool === true ? 'pink--text text--darken-1' : ''">
                                {{ item.number }}
                              </div>
                            </div>
  
                              </template>
      
                              <span>Akun ini adalah akun laba bulanan saldo akun ini diambil dari total pendapatan dikurangi biaya</span>
                            </v-tooltip>
                            <!-- <v-icon v-if="item.child">
                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                          </template>
                          <!-- <template v-slot:label="{item}">
                            <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                          </template> -->
                          <template v-slot:append="{ item }">
                            <div class="d-flex" v-if="item.laba_bool === false">
                              <div style="min-width: 500px; padding-left: 16px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.name }}
                              </div>
                              <div style="min-width: 300px; padding-left: 16px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.tag === '' || item.tag === null ? '-' : item.tag }}
                              </div>
                            </div>
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <div class="d-flex pink--text text--darken-1" v-bind="attrs"
                                  v-on="on" v-if="item.laba_bool === true" style="cursor: pointer;">
                                  <div style="min-width: 500px; padding-left: 16px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.name }}
                                  </div>
                                  <div style="min-width: 300px; padding-left: 16px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.tag === '' || item.tag === null ? '-' : item.tag }}
                                  </div>
                                </div>
                              </template>
      
                              <span>Akun ini adalah akun laba bulanan saldo akun ini diambil dari total pendapatan dikurangi biaya</span>
                            </v-tooltip>
                          </template>
                        </v-treeview>

                        <table style="width: 100%; position: sticky; top: 0; background: #fff; z-index: 1;">
                          <tr>
                            <td class="px-5 fs-12 font-weight-bold black_one py-2" style="min-width: 312px; border-top: 1px solid #eee;">
                              Modal
                            </td>
                          </tr>
                        </table>
                        <v-treeview
                          v-model="tree"
                          :items="list_modal"
                          item-key="id"
                          activatable
                          open-all
                          item-children="child"
                          item-text="test"
                          class="border_buttom_tree fs-12"
                        >
                          <template v-slot:prepend="{ item }">
                            <div class="d-flex" v-if="item.laba_bool === false">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.formSub = true; reset(item);"
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-square-edit-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Ubah</span>
                              </v-tooltip>
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    v-if="item.last === undefined"
                                    rounded
                                    @click="dialog.formSub = true; resetSub(item);"
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-plus-circle</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
      
                              <!-- <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="24"
                                    min-height="24"
                                    x-small
                                    rounded
                                    @click="dialog.status = true; reset(item);"
                                    color="orange"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-file-cancel</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Nonaktifkan</span>
                              </v-tooltip> -->
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    :disabled="item.id === '202'"
                                    rounded
                                    @click="dialog.delete = true; reset(item);"
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-trash-can-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Hapus</span>
                              </v-tooltip>
                              <div :class="item.child.length > 0 || item.is_parent === true ? 'font_weight_600' : ''">
                                {{ item.number }}
                              </div>
                            </div>
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                            <div class="d-flex" style="cursor: pointer;" v-bind="attrs"
                                  v-on="on" v-if="item.laba_bool === true">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.formSub = true; reset(item);"
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-square-edit-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Ubah</span>
                              </v-tooltip>
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    v-if="item.last === undefined"
                                    rounded
                                    @click="dialog.formSub = true; resetSub(item);"
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-plus-circle</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
      
                              <!-- <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="24"
                                    min-height="24"
                                    x-small
                                    rounded
                                    @click="dialog.status = true; reset(item);"
                                    color="orange"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-file-cancel</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Nonaktifkan</span>
                              </v-tooltip> -->
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.delete = true; reset(item);"
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-trash-can-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Hapus</span>
                              </v-tooltip>
                              <div :class="item.child.length > 0 || item.is_parent === true ? item.laba_bool === true ? 'pink--text text--darken-1 font_weight_600' : 'font_weight_600' : item.laba_bool === true ? 'pink--text text--darken-1' : ''">
                                {{ item.number }}
                              </div>
                            </div>
  
                              </template>
      
                              <span>Akun ini adalah akun laba bulanan saldo akun ini diambil dari total pendapatan dikurangi biaya</span>
                            </v-tooltip>
                            <!-- <v-icon v-if="item.child">
                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                          </template>
                          <!-- <template v-slot:label="{item}">
                            <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                          </template> -->
                          <template v-slot:append="{ item }">
                            <div class="d-flex" v-if="item.laba_bool === false">
                              <div style="min-width: 500px; padding-left: 16px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.name }}
                              </div>
                              <div style="min-width: 300px; padding-left: 16px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.tag === '' || item.tag === null ? '-' : item.tag }}
                              </div>
                            </div>
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <div class="d-flex pink--text text--darken-1" v-bind="attrs"
                                  v-on="on" v-if="item.laba_bool === true" style="cursor: pointer;">
                                  <div style="min-width: 500px; padding-left: 16px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.name }}
                                  </div>
                                  <div style="min-width: 300px; padding-left: 16px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                    {{ item.tag === '' || item.tag === null ? '-' : item.tag }}
                                  </div>
                                </div>
                              </template>
      
                              <span>Akun ini adalah akun laba bulanan saldo akun ini diambil dari total pendapatan dikurangi biaya</span>
                            </v-tooltip>
                          </template>
                        </v-treeview>
    
                        <table style="width: 100%; position: sticky; top: 0; background: #fff; z-index: 1;">
                          <tr>
                            <td class="px-5 fs-12 font-weight-bold black_one py-2" style="min-width: 312px; border-top: 1px solid #eee;">
                              Pendapatan
                            </td>
                          </tr>
                        </table>
                        <v-treeview
                          v-model="tree"
                          :items="list_pendapatan"
                          item-key="id"
                          activatable
                          open-all
                          item-children="child"
                          item-text="test"
                          class="border_buttom_tree fs-12"
                        >
                          <template v-slot:prepend="{ item }">
                            <!-- <v-icon v-if="item.child">
                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                            <div class="d-flex">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.formSub = true; reset(item);"
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-square-edit-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Ubah</span>
                              </v-tooltip>
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    v-if="item.last === undefined"
                                    rounded
                                    @click="dialog.formSub = true; resetSub(item);"
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-plus-circle</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.delete = true; reset(item);"
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-trash-can-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Hapus</span>
                              </v-tooltip>
                              <div :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600' : ''">
                                {{ item.number }}
                              </div>
                            </div>
                          </template>
                          <!-- <template v-slot:label="{item}">
                            <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                          </template> -->
                          <template v-slot:append="{ item }">
                            <div class="d-flex">
                              <div style="min-width: 500px; padding-left: 16px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.name }}
                              </div>
                              <div style="min-width: 300px; padding-left: 16px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.tag === '' || item.tag === null ? '-' : item.tag }}
                              </div>
                            </div>
                          </template>
                        </v-treeview>

                        <table style="width: 100%; position: sticky; top: 0; background: #fff; z-index: 1;">
                          <tr>
                            <td class="px-5 fs-12 font-weight-bold black_one py-2" style="min-width: 312px; border-top: 1px solid #eee;">
                              Hpp
                            </td>
                          </tr>
                        </table>
                        <v-treeview
                          v-model="tree"
                          :items="list_hpp"
                          item-key="id"
                          activatable
                          open-all
                          item-children="child"
                          item-text="test"
                          class="border_buttom_tree fs-12"
                        >
                          <template v-slot:prepend="{ item }">
                            <!-- <v-icon v-if="item.child">
                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                            <div class="d-flex">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.formSub = true; reset(item);"
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-square-edit-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Ubah</span>
                              </v-tooltip>
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    v-if="item.last === undefined"
                                    rounded
                                    @click="dialog.formSub = true; resetSub(item);"
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-plus-circle</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    :disabled="item.id === '280'"
                                    rounded
                                    @click="dialog.delete = true; reset(item);"
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-trash-can-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Hapus</span>
                              </v-tooltip>
                              <div :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600' : ''">
                                {{ item.number }}
                              </div>
                            </div>
                          </template>
                          <!-- <template v-slot:label="{item}">
                            <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                          </template> -->
                          <template v-slot:append="{ item }">
                            <div class="d-flex">
                              <div style="min-width: 500px; padding-left: 16px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.name }}
                              </div>
                              <div style="min-width: 300px; padding-left: 16px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.tag === '' || item.tag === null ? '-' : item.tag }}
                              </div>
                            </div>
                          </template>
                        </v-treeview>
    
                        <table style="width: 100%; position: sticky; top: 0; background: #fff; z-index: 1;">
                          <tr>
                            <td class="px-5 fs-12 font-weight-bold black_one py-2" style="min-width: 312px; border-top: 1px solid #eee;">
                              Biaya
                            </td>
                          </tr>
                        </table>
                        <v-treeview
                          v-model="tree"
                          :items="list_biaya"
                          item-key="id"
                          activatable
                          open-all
                          item-children="child"
                          item-text="test"
                          class="border_buttom_tree fs-12"
                        >
                          <template v-slot:prepend="{ item }">
                            <!-- <v-icon v-if="item.child">
                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                            <div class="d-flex">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.formSub = true; reset(item);"
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-square-edit-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Ubah</span>
                              </v-tooltip>
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    v-if="item.last === undefined"
                                    rounded
                                    @click="dialog.formSub = true; resetSub(item);"
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-plus-circle</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.delete = true; reset(item);"
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-trash-can-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Hapus</span>
                              </v-tooltip>
                              <div :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600' : ''">
                                {{ item.number }}
                              </div>
                            </div>
                          </template>
                          <!-- <template v-slot:label="{item}">
                            <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                          </template> -->
                          <template v-slot:append="{ item }">
                            <div class="d-flex">
                              <div style="min-width: 500px; padding-left: 16px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.name }}
                              </div>
                              <div style="min-width: 300px; padding-left: 16px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.tag === '' || item.tag === null ? '-' : item.tag }}
                              </div>
                            </div>
                          </template>
                        </v-treeview>

                        <table style="width: 100%; position: sticky; top: 0; background: #fff; z-index: 1;">
                          <tr>
                            <td class="px-5 fs-12 font-weight-bold black_one py-2" style="min-width: 312px; border-top: 1px solid #eee;">
                              Pendapatan Lain - Lain
                            </td>
                          </tr>
                        </table>
                        <v-treeview
                          v-model="tree"
                          :items="list_pendapatan_lain"
                          item-key="id"
                          activatable
                          open-all
                          item-children="child"
                          item-text="test"
                          class="border_buttom_tree fs-12"
                        >
                          <template v-slot:prepend="{ item }">
                            <!-- <v-icon v-if="item.child">
                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                            <div class="d-flex">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.formSub = true; reset(item);"
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-square-edit-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Ubah</span>
                              </v-tooltip>
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    v-if="item.last === undefined"
                                    rounded
                                    @click="dialog.formSub = true; resetSub(item);"
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-plus-circle</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    :disabled="item.id === '281'"
                                    @click="dialog.delete = true; reset(item);"
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-trash-can-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Hapus</span>
                              </v-tooltip>
                              <div :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600' : ''">
                                {{ item.number }}
                              </div>
                            </div>
                          </template>
                          <!-- <template v-slot:label="{item}">
                            <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                          </template> -->
                          <template v-slot:append="{ item }">
                            <div class="d-flex">
                              <div style="min-width: 500px; padding-left: 16px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.name }}
                              </div>
                              <div style="min-width: 300px; padding-left: 16px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.tag === '' || item.tag === null ? '-' : item.tag }}
                              </div>
                            </div>
                          </template>
                        </v-treeview>

                        <table style="width: 100%; position: sticky; top: 0; background: #fff; z-index: 1;">
                          <tr>
                            <td class="px-5 fs-12 font-weight-bold black_one py-2" style="min-width: 312px; border-top: 1px solid #eee;">
                              Biaya Lain - Lain
                            </td>
                          </tr>
                        </table>
                        <v-treeview
                          v-model="tree"
                          :items="list_biaya_lain"
                          item-key="id"
                          activatable
                          open-all
                          item-children="child"
                          item-text="test"
                          class="border_buttom_tree fs-12"
                        >
                          <template v-slot:prepend="{ item }">
                            <!-- <v-icon v-if="item.child">
                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else>{{ 'mdi-file-document-outline' }}</v-icon> -->
                            <div class="d-flex">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    @click="dialog.formSub = true; reset(item);"
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-square-edit-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Ubah</span>
                              </v-tooltip>
      
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    v-if="item.last === undefined"
                                    rounded
                                    @click="dialog.formSub = true; resetSub(item);"
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-plus-circle</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Tambah</span>
                              </v-tooltip>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    min-width="20"
                                    min-height="20"
                                    x-small
                                    rounded
                                    :disabled="item.id === '283'"
                                    @click="dialog.delete = true; reset(item);"
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="12">mdi-trash-can-outline</v-icon>
                                    
                                  </v-btn>
                                </template>
        
                                <span>Hapus</span>
                              </v-tooltip>
                              <div :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600' : ''">
                                {{ item.number }}
                              </div>
                            </div>
                          </template>
                          <!-- <template v-slot:label="{item}">
                            <div class="v-treeview-node__label">{{item.data.name_label}}</div>
                          </template> -->
                          <template v-slot:append="{ item }">
                            <div class="d-flex">
                              <div style="min-width: 500px; padding-left: 16px;" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.name }}
                              </div>
                              <div style="min-width: 300px; padding-left: 16px;" calss="text-capitalize" :class="item.child.length > 0 || item.is_parent === true  ? 'font_weight_600 fs-11' : 'fs-11'">
                                {{ item.tag === '' || item.tag === null ? '-' : item.tag }}
                              </div>
                            </div>
                          </template>
                        </v-treeview>
                      </div>
  
                      <v-card-text
                        v-if="list.length === 0"
                        class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <v-img 
                            class="mx-auto"
                            contain
                            alt="vuetify"
                            :width="90"
                            :height="90"
                            :src="require('@/assets/image/empty.png')">
                            <!-- <template v-slot:placeholder>
                              <v-row
                                class=" "
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template> -->
                          </v-img>
                          <div class="mt-3 fs-16">
                            Belum Ada Aktiva
                          </div>
                        </div>
                      </v-card-text>
                    </div>
                  </v-card-text>
                </v-card>
                <!-- <v-card 
                  flat
                  style="border-radius: 10px; border-top: 1px solid #E7E7E7; width: 100%;">
  
                  <v-card-text class="px-0 pt-0 pb-2">
                    <div v-if="!process.load">
                      <table style="width: 100%;">
                        <tr>
                          <td class="px-5 fs-12 font-weight-bold py-1" style="background: #080679; width: 100%; color: #080679;">
                            text
                          </td>
                        </tr>
                      </table>
                    </div>
                  </v-card-text>
                </v-card> -->
              </div>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        checkbox_test: false,

        expanded_program: [],

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false,
          status: false,
          formSub: false,
        },
        category: [], 
        
        search: '',

        filter: {
          year: new Date().getFullYear(),
        },
        tree: [],
        parent: [],

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: []
        },

        role: [],

        options: {},
        headers: [],
        list: [],
        list_aktiva: [],
        list_pasiva: [],
        list_modal: [],
        list_pendapatan: [],
        list_hpp: [],
        list_pendapatan_lain: [],
        list_biaya: [],
        list_biaya_lain: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        name_par: '',

        form: {
          id: '',
          name: '',
          par_id: '',
          number: '',
          type: '',
          tag: '',
          year: '',
          position: '',
          active_bool: true,
          laba_bool: false,
        },

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue'),
      // TreeContainer: () => import(/* webpackPrefetch: true */ '@/components/TreeContainer')
    },
    watch: {
      'filter.year': function () {
        this.fetch()
      },
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      years () {
        let max = new Date().getFullYear()+4, min = max - 8, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
    },
    mounted () {
      this.fetch()
      // this.fetchParent()
      // this.fetchCategory()
      // this.form.outlet_id = this.user.cat_title === 'Owner' ? this.outlet.outlet_id : ''
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)

        this.expanded_program = []

        // this.expanded_kegiatan = []

        this.selected.row_kegiatan = []

        // this.selected.row_sub_kegiatan = []

        if (row.isExpanded) {
          const indexExpanded = this.expanded_program.findIndex(i => i === item)
          this.expanded_program.splice(indexExpanded, 1)
        } else {
          this.expanded_program.push(item)
        }
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetchParent () {
        this.process.load = true

        let params = {
          // limit: pagination.row,
          // page: pagination.page,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          // type: 'aktiva'
        }

        // this.selected.row = []

        await get(`coa/data_list`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.parent = []
            
          if (res.status === 200) {

            this.parent = res.results.data
          }
        })
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          // limit: pagination.row,
          // page: pagination.page,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          // type: 'aktiva',
          year: this.filter.year
        }

        this.selected.row = []

        await get(`coa/all`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '116px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama',
                width: '100%',
                value: 'name',
                freeze: false,
                hide: false
              }
            ]

            res.results.data.aktiva.map((item, index) => {
              // if(res.results.data === 'aktiva') {
                this.list.push(item)
              // }
            })

            res.results.data.pasiva.map((item, index) => {
              // if(res.results.data === 'pasiva') {
                this.list.push(item)
              // }
            })

            res.results.data.biaya.map((item, index) => {
              // if(res.results.data === 'biaya') {
                this.list.push(item)
              // }
            })

            res.results.data.pendapatan.map((item, index) => {
              // if(res.results.data === 'pendapatan') {
                this.list.push(item)
              // }
            })

            let list = []
            let last_list = []

            this.list.map((item, index) => {
              list.push({
                ...item,
                is_parent: true
              })
              if(item.child.length > 0) {
                item.child.map((ch1, i) => {
                  if(ch1.child.length > 0) {
                    ch1.child.map((ch2, i2) => {
                     if(ch2.child.length > 0) {
                      ch2.child.map((ch3, i3) => {

                        last_list.push({
                          ...ch3,
                          last: true
                        })

                        // return last
                        // console.log(ch3)
                        // ch2.child[i3] = last
                        // ch2.child.push(last)
                        // if(ch3.child.length > 0) {
                        //   ch3.map(ch4 => {
                        //     return {
                        //       ...ch4,
                        //       last: true
                        //     }
                        //   })
                        //   // console.log(ch3)
                        //   ch3.child.map((ch4, i4) => {
                        //     ch4.map(ch5 => {
                        //       return {
                        //         ...ch5,
                        //         last: true
                        //       }
                        //     })
                        //   })
                        // }
                        // ch3 = last_list
                        // console.log(ch3)
                        // return ch3
                        // ch2.child[i3] = last_list[i3]
                        last_list.map((last, i4) => {

                          ch2.child[i3] = last_list[i4]
                        })
                      })
                      // console.log(ch2.child)
                     }
                    })
                  }
                })
              }
            })

            // console.log(list)

            this.list = list
            this.list_aktiva = []
            this.list_pasiva = []
            this.list_modal = []
            this.list_pendapatan = []
            this.list_hpp = []
            this.list_pendapatan_lain = []
            this.list_biaya = []
            this.list_biaya_lain = []

            this.list.map((item, index) => {
              if(item.type === 'aktiva') {
                this.list_aktiva.push(item)
              }

              if(item.type === 'pasiva') {
                if(item.id !== '202'){
                  this.list_pasiva.push(
                    item
                  )
                }
              }

              if(item.id === '202') {
                this.list_modal.push(item)
              }

              if(item.type === 'pendapatan') {
                if(item.id !== '281'){
                  this.list_pendapatan.push(
                    item
                  )
                }
              }

              if(item.id === '281') {
                this.list_pendapatan_lain.push(item)
              }

              if(item.type === 'biaya') {
                if(item.id !== '280' && item.id !== '283'){
                  this.list_biaya.push(
                    item
                  )
                }
              }

              if(item.id === '280') {
                this.list_hpp.push(item)
              }

              if(item.id === '283') {
                this.list_biaya_lain.push(item)
              }
            })

            // // res.results.data.map((item, index) => {
            //   // if(res.results.data === 'pasiva') {
            //     this.list.push(res.results.data.pasiva)
            //   // }
            // // })

            // // res.results.data.map((item, index) => {
            //   // if(res.results.data === 'biaya') {
            //     this.list.push(res.results.data.biaya)
            //   // }
            // // })

            // // res.results.data.map((item, index) => {
            //   // if(res.results.data === 'pendapatan') {
            //     this.list.push(res.results.data.pendapatan)
            //   // }
            // // })
            // // this.pagination = res.results.pagination


            // this.lastIndex = (pagination.page - 1) * pagination.row 
            // this.lastIndex += 1

            // this.addFreezes()

            // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.par_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? index.id : '',
          name: index !== undefined ? index.name : '',
          par_id: index !== undefined ? index.par_id : '0',
          number: index !== undefined ? index.number : '',
          type: index !== undefined ? index.type : '',
          tag: index !== undefined ? index.tag : '',
          // year: index !== undefined ? index.year : new Date().getFullYear(),
          active_bool: index !== undefined ? index.active_bool : true,
          position: '',
          laba_bool: index !== undefined ? index.laba_bool : false
        }

        this.process.form = false

        this.message.error = ''
      },

      resetSub (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: '',
          name: '',
          par_id: index.id,
          number: '',
          type: index.type,
          tag: '',
          // year: (index.year*1),
          position: ''
        }
        this.name_par = index.name

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.form.tag = this.form.tag === null ? '' : this.form.tag
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          if (this.form.id !== '') {
            this.form = {
              type: this.form.type,
              id: this.form.id,
              name: this.form.name,
              tag: this.form.tag,
              number: this.form.number,
              active_bool: this.form.active_bool,
              position: 'internal',
              laba_bool: this.form.laba_bool
            }
          }
          this.form.laba_bool = this.form.type === 'pasiva' ? this.form.laba_bool : false

          let url = this.form.id === '' ? 'coa/add' : 'coa/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false
              this.dialog.formSub = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              if (this.form.id === '') {
                this.fetch()
              } else {
                this.fetch()
              }
              // this.fetchParent()
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async toStatus() {
        this.process.delete = true

        await post(`coa/update`, {
          data: {
            id: this.form.id,
            active_bool: !this.form.active_bool === true ? false : true
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {
            this.dialog.status = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
            // this.fetchParent()
            this.reset()
          } else {
            this.message.error = res.message
          }
        })
      },

      // toDelete (id) {
      //   this.selected.delete = [id]

      //   this.dialog.delete = true
      // },
      async toDelete () {
        this.message.error = ''

        this.process.delete = true

        await post(`coa/delete`, {
          data: {
            id: this.form.id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
            // this.fetchParent()
            this.reset()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>


<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

</style>